export function ezRand() {
    return ~~(Math.random() * 1000000)
}

export function randID(): string {
    return Math.random().toString(36).slice(2, 10).padEnd(8, "0")
}

export function rand(
    min: number,
    max: number,
    rounded: boolean = true
): number {
    const random = Math.random() * (max - min) + min
    if (rounded) return ~~random
    return random
}

export function randBrightColor() {
    return `hsla(${~~(256 * Math.random())},100%,50%,1)`
}

export function appendTimestampToFileName(fileName: string): string {
    const timestamp = Date.now()
    const extensionRegex = /(\.([^.]+))$/

    return fileName.match(extensionRegex)
        ? fileName.replace(
              extensionRegex,
              extension => `_${timestamp}${extension}`
          )
        : `${fileName}_${timestamp}`
}
